import {
	ImageReference,
	OptimizelyBoolean,
	OptimizelyLongString,
	OptimizelyXhtmlString,
} from '../index';
import { OptimizelyBlockExpandedValue } from '../expanded';

export interface BasicAccordionBlock extends OptimizelyBlockExpandedValue {
	contentType: ['Block', 'AccordionBlock'];
}

export interface ExpandedFeatureBlock extends OptimizelyBlockExpandedValue {
	contentType: ['Block', 'FeatureBlock'];
	text: OptimizelyXhtmlString;
	title: OptimizelyLongString;
	image: ImageReference;
	showTitle: OptimizelyBoolean;
	useImageAsHorizontal: OptimizelyBoolean;
}

export interface ExpandedAccordionBlock extends BasicAccordionBlock {
	title: OptimizelyLongString;
	fontColor: OptimizelyLongString;
	backgroundColor: OptimizelyLongString;
	features: {
		expandedValue: ExpandedFeatureBlock[];
	};
}

export const isAccordionBlock = (
	block: OptimizelyBlockExpandedValue,
): block is BasicAccordionBlock => {
	return block.contentType[1] === 'AccordionBlock';
};

export interface AccordionItem {
	title: string;
	description: string;
	imageUrl: string;
	showTitle: boolean;
	useImageAsHorizontal: boolean;
}

export interface AccordionBlockData {
	title: string;
	fontColor: string;
	backgroundColor: string;
	items: AccordionItem[];
}
